import React, { ReactElement } from "react";
import {
  AoVerzekering,
  AovHoofdstuk
} from "../../../../.generated/rapportage/rapportagetypes";
import { Chapter } from "../../components/Chapter";
import Heading from "../../components/Heading";
import { Paragraph } from "../../components/Paragraph";
import Table from "../../components/Table";
import { getAovColumns } from "../Producten/aov-kolommen";

type ArbeidsongeschiktheidsverzekeringChapterProps = {
  hoofdstuk: AovHoofdstuk;
};

const AovVerzekering = ({
  aoVerzekering,
}: {
  aoVerzekering: AoVerzekering;
}): ReactElement => {
  return (
    <Table
      columns={getAovColumns({ aoVerzekering: aoVerzekering, isHuidig: false })}
      data={[aoVerzekering]}
      id="aov-table"
      data-testid="aov-table"
      rotate
      filterNullAnd0Columns={true}
    />
  );
};

const ArbeidsongeschiktheidsverzekeringChapter = ({
  hoofdstuk,
}: ArbeidsongeschiktheidsverzekeringChapterProps): ReactElement => {
  return (
    <>
      {hoofdstuk.verzekeringen && hoofdstuk.verzekeringen?.length > 0 && (
        <Chapter>
          <div className="break-avoid">
            {hoofdstuk.titel && (
              <Heading text={`${hoofdstuk.titel}`} level={3} />
            )}

            <Paragraph paragraaf={hoofdstuk?.paragrafen?.["p305060401"]} />

            {hoofdstuk.verzekeringen
              ?.slice(0, 1)
              .map((verzekering: AoVerzekering, index) => {
                return (
                  <AovVerzekering key={index} aoVerzekering={verzekering} />
                );
              })}
          </div>
          {hoofdstuk.verzekeringen
            ?.slice(1)
            .map((verzekering: AoVerzekering, index) => {
              return (
                <AovVerzekering key={index + 1} aoVerzekering={verzekering} />
              );
            })}
        </Chapter>
      )}
    </>
  );
};

export default ArbeidsongeschiktheidsverzekeringChapter;
